import { createContext } from 'react';
// HACK: This works around typescript thinking this context can be undefined.
// It will always have a value at runtime, but I don't know how to tell
// typescript that yet.
export const StoreContext = /*#__PURE__*/createContext(undefined);